const normalizeName = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/[,，]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

const englishKeys = (surname, givenName) => {
  const family = normalizeName(surname);
  const given = normalizeName(givenName);
  const keys = new Set();
  if (family && given) {
    keys.add(`${family} ${given}`);
    keys.add(`${given} ${family}`);
  } else if (family || given) {
    keys.add(family || given);
  }
  return keys;
};

const personMatch = (row) => ({
  kind: "person",
  englishName: row.englishName || "",
  chineseName: row.chineseName || "",
  companyName: row.companyName || "",
  companyRole: row.companyRole || "",
});

const corporateMatch = (row) => ({
  kind: "corporate",
  englishName: row.englishName || "",
  chineseName: row.chineseName || "",
  formerlyKnownEnglish: row.formerlyKnownEnglish || "",
  formerlyKnownChinese: row.formerlyKnownChinese || "",
  countryOfIncorporation: row.countryOfIncorporation || "",
});

const screenIndividual = (client, persons) => {
  const keys = englishKeys(client?.surname, client?.givenName);
  const chinese = normalizeName(client?.cname);
  if (!keys.size && !chinese) return { status: "EMPTY" };

  const clientNames = new Set([...keys]);
  if (chinese) clientNames.add(chinese);

  const matches = (persons || [])
    .filter((row) => {
      const rowNames = [row?.englishName, row?.chineseName]
        .map(normalizeName)
        .filter(Boolean);
      return rowNames.some((name) => clientNames.has(name));
    })
    .map(personMatch);

  return matches.length ? { status: "MATCH", matches } : { status: "PASS" };
};

const screenCorporate = (client, corporates) => {
  const english = normalizeName(client?.name);
  const chinese = normalizeName(client?.cname);
  if (!english && !chinese) return { status: "EMPTY" };

  const matches = (corporates || [])
    .filter((row) => {
      const names = [
        row?.englishName,
        row?.formerlyKnownEnglish,
        row?.chineseName,
        row?.formerlyKnownChinese,
      ].map(normalizeName);
      return names.some(
        (name) => name && (name === english || name === chinese)
      );
    })
    .map(corporateMatch);

  return matches.length ? { status: "MATCH", matches } : { status: "PASS" };
};

export const screenRelatedParty = (client, lists = {}) => {
  if (client?.type === "CORPORATE") {
    return screenCorporate(client, lists.corporates);
  }
  return screenIndividual(client, lists.persons);
};
